import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse, Result } from "../../types/Result";
import { EmailLog } from "./type";

export const emailLogListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<EmailLog>>(
    url.search
      ? `/api/emaillogs${url.search}`
      : "/api/emaillogs?sort.field=creationTime&sort.sort=desc&pageSize=50"
  );
  return result.data;
};

export const emailLogLoader: LoaderFunction = async ({ params }) => {
  const result = await axiosApi.get<Result<EmailLog>>(`/api/emaillogs/${params.id}`);
  return result.data;
};

export const retryEmailLog = async (id: string) => {
  return await axiosApi.post<Result<EmailLog>>(`/api/emaillogs/${id}/retry`);
};
